import { ICalendarState, CalendarActions, IEventMonth, IEvent } from '@adage/ace-calendar';
import { jump } from '../../Static/javascript/modules/jump-scrolling';
import * as moment from 'moment';
import { find } from 'lodash';

function isSameMonth(a: moment.Moment, b: moment.Moment): boolean {
    return a.month() === b.month() && a.year() === b.year();
}

export function JumpToFirstEventMonth(isMobile) {
    var myVar = setInterval(() => {
        if (CalendarActions.calendarState().events.length > 0) {
            /** events have changed */
            const events = CalendarActions.calendarState().events;

            var monthStartDate = CalendarActions.calendarState().startDate;
            const currMonth = CalendarActions.calendarState().currentDate;
            const eventMonths = events.filter(eventMonth => eventMonth.events.length > 0);

            console.log(CalendarActions.calendarState().eventFilter.length);

            if (eventMonths && eventMonths.length > 0 && !eventMonths.some(eventMonth => isSameMonth(eventMonth.monthMoment, currMonth))) {
                // We know there's at least one event.
                const firstEventAfter = find(eventMonths, eventMonth => eventMonth.events.length > 0 && eventMonth.monthMoment.isAfter(currMonth));
                const firstEvent = firstEventAfter ? firstEventAfter.events[0] : eventMonths[0].events[0];

                if (!CalendarActions.calendarState().updating && firstEvent) {
                    if (isMobile) {
                        jump(`${moment(firstEvent.eventDate).format("YYYY-MM")}`, {
                            duration: 0,
                            offest: 1
                        });
                    }
                    else {
                        CalendarActions.goToMonth(eventMonths[0].monthMoment);
                    }
                    clearInterval(myVar);
                }
            } else if (eventMonths && eventMonths.length > 0) {
                // This is the case where the data has loaded, but there are events in the same month. This should just cause the interval to disappear.
                clearInterval(myVar);
            }
        }

        this.setState({ events: CalendarActions.calendarState().events });
    }, 500);
}


// WEBPACK FOOTER //
// ./app/calendar/calendar-helpers.ts